import { useState } from "react";
import type { Contract } from "@/lib/api";
import { statusLabels, type ContractStatus } from "@/lib/constants";

interface FilterBarProps {
  contracts: Contract[];
  onFilter: (filtered: Contract[]) => void;
}

const STATUS_OPTIONS = Object.entries(statusLabels) as [ContractStatus, string][];

export default function FilterBar({ contracts, onFilter }: FilterBarProps) {
  const [department, setDepartment] = useState("");
  const [status, setStatus] = useState("");

  const departments = [...new Set(contracts.map((c) => c.department))].sort();

  const apply = (dept: string, st: string) => {
    let filtered = [...contracts];
    if (dept) filtered = filtered.filter((c) => c.department === dept);
    if (st) filtered = filtered.filter((c) => c.status === st);
    onFilter(filtered);
  };

  return (
    <div className="flex flex-col sm:flex-row flex-wrap gap-3 mb-4">
      <select
        value={department}
        onChange={(e) => { setDepartment(e.target.value); apply(e.target.value, status); }}
        className="h-9 px-3 border border-background-300 rounded-md text-sm text-foreground-700 bg-white focus:outline-none focus:border-primary-500 cursor-pointer"
      >
        <option value="">All Departments</option>
        {departments.map((d) => (<option key={d} value={d}>{d}</option>))}
      </select>

      <select
        value={status}
        onChange={(e) => { setStatus(e.target.value); apply(department, e.target.value); }}
        className="h-9 px-3 border border-background-300 rounded-md text-sm text-foreground-700 bg-white focus:outline-none focus:border-primary-500 cursor-pointer"
      >
        <option value="">All Statuses</option>
        {STATUS_OPTIONS.map(([val, label]) => (<option key={val} value={val}>{label}</option>))}
      </select>

      <button
        onClick={() => { setDepartment(""); setStatus(""); onFilter(contracts); }}
        className="h-9 px-3 border border-background-300 text-foreground-600 text-sm font-medium rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
      >
        Clear
      </button>
    </div>
  );
}
